import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-http-error',
    template: `
    @if (httpErrorResponse) {
      <app-toast type="Error" class="tw-w-full">
        @if (httpErrorResponse.status === 400) {
          <div class="tw-flex tw-flex-wrap tw-flex-col">
            <div class="tw-w-full">
              <span class="header-font">{{
                httpErrorResponse?.error?.title
              }}</span>
            </div>
            <div class="tw-w-full">
              <ul>
                @for (error of getErrors(); track error) {
                  <li>
                    {{ error.key }}: {{ error.message }}
                  </li>
                }
              </ul>
            </div>
          </div>
        }
        @if (httpErrorResponse.status === 401) {
          Unauthorized
        }
        @if (httpErrorResponse.status >= 500) {
          {{ httpErrorResponse | json }}
        }
      </app-toast>
    }
    `,
    styles: [
        `
           .header-font {
             font-size: 16px;
           }
         `,
    ],
    standalone: false
})
export class HttpErrorComponent implements OnInit {
  @Input()
  httpErrorResponse: HttpErrorResponse;

  constructor() {}

  ngOnInit(): void {}

  getErrors(): ValidationError[] {
    let result: ValidationError[] = [];
    if (!this.httpErrorResponse) {
      return result;
    }

    let errors = this.httpErrorResponse.error.errors;

    for (const key in errors) {
      result.push(new ValidationError(key, errors[key][0]));
    }

    return result;
  }
}

class ValidationError {
  constructor(public key: string, public message: string) {}
}
